import { Link, graphql } from 'gatsby';
import React, { useState, useEffect } from "react";
import "../styles/categories.scss"
import SecondaryLayout from "../layouts/secondary-layout";
import List from '../components/list/list';
import ProductsList from '../components/list/products-list';
import CocktailsJson from '../assets/menuJson/cocktails.json';
import BirreJson from '../assets/menuJson/birre.json';
import SoftDrinksJson from '../assets/menuJson/softDrinks.json';
import SpiritsAndLiquersJson from '../assets/menuJson/spiritsAndLiquers.json';
import WineByTheGlassJson from '../assets/menuJson/wineByTheGlass.json';
import WineByTheBottleJson from '../assets/menuJson/wineByTheBottle.json';
import PrimiJson from '../assets/menuJson/primi.json';
import AntipastiJson from '../assets/menuJson/antipasti.json';
import SecondiJson from '../assets/menuJson/secondi.json';
import ContorniJson from '../assets/menuJson/contorni.json';
import DolciJson from '../assets/menuJson/dolci.json';
import CoffeeJson from '../assets/menuJson/coffee.json';
import NibblesJson from '../assets/menuJson/nibbles.json';

export const query = graphql`
  query MenuTypesList ($id: Int) {
    strapiMenuTypes(strapiId: { eq: $id }) {
        Title
        Slug
        submenu_types {
            created_at
            published_at
            Title
            Slug
          }
    }
    strapiSiteSettings {
        DisclaimerAllergies
        FoodURL
        DrinksURL
    }
  }
`;

const HardcodedCategories = ({ data }) => {
    const { Title, Slug, submenu_types } = data?.strapiMenuTypes

    submenu_types.sort(function (firstType, secondType) {

        let secondDate = secondType.created_at;
        let firstDate = firstType.created_at;

        return new Date(firstDate) - new Date(secondDate);
    });

    let contentsList = [];

    let categoryLocation = ""
    if (typeof window !== 'undefined' && window.location.search.split('=').length > 1) {
        categoryLocation = window.location.search.split('=')[1];
    }

    switch(categoryLocation){
        case "nibbles":
            contentsList = NibblesJson;
            break;
        case "primi":
            contentsList = PrimiJson;
            break;
        case "secondi":
            contentsList = SecondiJson;
            break;
        case "antipasti":
            contentsList = AntipastiJson;
            break;
        case "contorni":
            contentsList = ContorniJson;
            break;
        case "dolci":
            contentsList = DolciJson;
            break;
        case "aperitivi":
            contentsList = CocktailsJson;
            break;
        case "wine-glass":
            contentsList = WineByTheGlassJson;
            break;
        case "wine-bottle":
            contentsList = WineByTheBottleJson;
            break;
        case "spirits":
            contentsList = SpiritsAndLiquersJson;
            break;
        case "birre":
            contentsList = BirreJson;
            break;
        case "soft-drinks":
            contentsList = SoftDrinksJson;
            break;
        case "coffee":
            contentsList = CoffeeJson;
            break;
    }

    // const sortedProducts = contentsList.map(group => ({
    //                         ...group,
    //                         Products: [...group.Products].sort((a, b) => a.Price - b.Price)
    //                     }));
    const sortedProducts = contentsList.map(group => {
        const sauces = group.Products.filter(p => p.Title === "Sauces");
        const others = group.Products.filter(p => p.Title !== "Sauces");

        return {
            ...group,
            Products: [
            ...others.sort((a, b) => a.Price - b.Price),
            ...sauces,
            ],
        };
    });

    return (

        <SecondaryLayout SEOTitle={""} SEODescription={""}>
            <div className="categories-font">
                <div className="page-content">
                    <div>
                        <h1 className="page-title">{Title}</h1>
                        <p className="complementary-subtitle">
                            ..or see our<a href={Title == "Drinks" ? data.strapiSiteSettings.FoodURL : data.strapiSiteSettings.DrinksURL}>{Title == "Drinks" ? " ‎ food ‎ " : " ‎ drinks ‎ "}</a>menu &#128522;</p>
                    </div>

                    <div className="menu-list">
                        <ul className="categories-list">

                            {
                                submenu_types ?
                                    submenu_types.map((item, index) => {
                                        return (
                                            <li key={index} className="category">
                                                <Link to={`/menu/${Slug}/?type=` + item.Slug} className={`${item.Slug == categoryLocation ? "category-link-selected" : "category-link"}`}>
                                                    {item.Title}
                                                </Link>
                                            </li>
                                        )
                                    })
                                    : ""
                            }

                        </ul>
                        {Title == "Food" ?
                        <>
                        <p className="complementary-subtitle">...or our set menu for groups of 8 or more people <br/>(please confirm your reservation and menu choice at least 24 hours before your visit)</p>
                        <ul className="categories-list"> 
                            <li className="category"> <a href={'/assets/classic-menu.pdf?t='+new Date().getTime()} target="_blank" rel="noopener noreferrer" className="category-link">Classic set menu</a></li>
                            <li className="category"> <a href={'/assets/gourmet-menu.pdf?t='+new Date().getTime()} target="_blank" rel="noopener noreferrer" className="category-link">Gourmet set menu</a></li>
                            {/* <li className="category"> <a href={'/assets/indulgence-menu.pdf?t='+new Date().getTime()} target="_blank" rel="noopener noreferrer" className="category-link">Indulgence set menu</a></li> */}
                        </ul>
                        </>:""
                        }
                    </div>

                    {
                        sortedProducts ?
                            <div className="products-listing">
                                <ProductsList
                                    contents={sortedProducts}
                                ></ProductsList>

                                {
                                    data.strapiSiteSettings.DisclaimerAllergies ?
                                        (Title == "Food" || Title == "Dessert") ?
                                            <div className="disclaimer">
                                                <p>{data.strapiSiteSettings.DisclaimerAllergies}</p>
                                            </div>
                                            : ""
                                        : ""
                                }

                            </div>
                            : ""
                    }


                </div>
            </div>
        </SecondaryLayout>

    )
    
} 

export default HardcodedCategories;